
import { Button } from "@/components/ui/button";
import { useTheme } from "@/lib/theme/ThemeContext";

interface ConfirmationDialogProps {
  childName?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmationDialog({
  childName,
  onCancel,
  onConfirm
}: ConfirmationDialogProps) {
  const isLightTheme = false;

  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
      <div className={`${isLightTheme ? "bg-white" : "bg-[#1A1F2C]"} rounded-lg shadow-xl max-w-md w-full p-6 border ${isLightTheme ? "border-slate-200" : "border-[#333333]/80"} ${!isLightTheme && "neo-blur"}`}>
        <h3 className={`text-lg font-semibold mb-4 ${isLightTheme ? "text-slate-900" : "text-[#D6BCFA]"}`}>Save Sleep Record?</h3>
        <p className={`mb-6 ${isLightTheme ? "text-slate-700" : "text-[#C8C8C9]"}`}>
          You're about to save this sleep record for {childName || 'your baby'}. 
          Please review the details before confirming.
        </p>
        <div className="flex gap-3 justify-end">
          <Button 
            variant="outline" 
            onClick={onCancel}
            type="button"
            className={isLightTheme 
              ? "border-slate-200 bg-white hover:bg-slate-50"
              : "border-[#333333] bg-[#222222] hover:bg-[#333333] hover:text-[#D6BCFA]"
            }
          >
            Back to Edit
          </Button>
          <Button 
            variant="default"
            onClick={onConfirm}
            type="button"
            className={isLightTheme
              ? "bg-blue-primary hover:bg-blue-600 text-white"
              : "bg-[#9b87f5] hover:bg-[#9b87f5]/90 text-white"
            }
          >
            Confirm and Save
          </Button>
        </div>
      </div>
    </div>
  );
}
